/**
 * File: custom-bullets.js
 *
 * Import and initialize functions for custom bullets
 */

 export default {
	init() {
		this.render();
	},
	render() {
		const customLists = document.querySelectorAll('#custom-bullets, #custom-bullets-1');
		const customBullet = `<span aria-hidden="true" tabindex="-1">&#59392;</span>`;

		customLists.forEach(list => {
			const items = list.querySelectorAll('li');

			items.forEach(item => item.insertAdjacentHTML('afterbegin', customBullet));
		});
	},
  };
